module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-220.4ca3e543.svg";